<script>
    export default {
        inserted: function (el) {
            let tabs = el.querySelectorAll('ul li');
            let rows = el.querySelectorAll('.polaris-products');

            let setOnclick = (element) => {
                element.onclick = (e) => {
                    e.preventDefault();
                    reset();
                    for (let tab of tabs) {
                        if (tab.dataset.type === element.dataset.type) {
                            element.classList.add('active');
                        }
                    }

                    for (let row of rows) {
                        console.log(row.dataset.type, element.dataset.type);
                        if (row.dataset.type === element.dataset.type) {
                            row.style.display = 'flex';
                        }
                    }
                }
            }
            for (let tab of tabs) {
                setOnclick(tab);
            }

            let reset = () => {
                for (let tab of tabs) {
                    tab.classList.remove('active');
                }

                for (let row of rows) {
                    row.style.display = 'none';
                }
            }
        }
    }

</script>
